export default {
    'activity_id': 'Activiteit'
}
